export const handleProfileRedirect = (user) => {
  if (!user) return;
  
  if (user.u_is_new_user || !user.u_first_name || !user.u_last_name) {
    return `/profile/id/${user.u_id}`;
  }
  
  // Include user ID in all profile URLs to ensure uniqueness
  return `/profile/${user.u_id}-${user.u_first_name.toLowerCase()}_${user.u_last_name.toLowerCase()}`;
};